import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const
};

export const DonationIcon = createSvgIcon(
  <>
    <path
      d="M9.19684 11.2621H11.0406C11.5296 11.2621 11.9985 11.0678 12.3443 10.7221C12.6901 10.3763 12.8843 9.90733 12.8843 9.41833C12.8843 8.92934 12.6901 8.46038 12.3443 8.11461C11.9985 7.76884 11.5296 7.57459 11.0406 7.57459H8.27497C7.72184 7.57459 7.26091 7.75897 6.98435 8.12771L1.82187 13.1058M5.50935 16.7933L6.98435 15.5027C7.26091 15.134 7.72184 14.9496 8.27497 14.9496H11.9625C12.9765 14.9496 13.8984 14.5808 14.5437 13.8433L18.7843 9.78711C19.14 9.45093 19.3477 8.9872 19.3615 8.49793C19.3753 8.00867 19.1942 7.53395 18.8581 7.17821C18.5219 6.82247 18.0581 6.61485 17.5689 6.60102C17.0796 6.58719 16.6049 6.76828 16.2492 7.10446L12.3773 10.6998M0.899994 12.1839L6.43122 17.7152M17.0329 6.19178C17.6782 5.54647 18.4157 4.71679 18.4157 3.70273C18.4801 3.1394 18.3524 2.57082 18.0533 2.08912C17.7542 1.60743 17.3012 1.24085 16.7677 1.04879C16.2343 0.856738 15.6515 0.85046 15.114 1.03098C14.5765 1.21149 14.1158 1.56822 13.8063 2.04336C13.4773 1.60509 13.0163 1.28386 12.4912 1.12682C11.9661 0.969789 11.4045 0.985226 10.8889 1.17087C10.3732 1.35651 9.93062 1.70258 9.62611 2.15827C9.3216 2.61396 9.1712 3.15527 9.19698 3.70273C9.19698 4.80898 9.93447 5.54647 10.5798 6.28397L13.8063 9.41834L17.0329 6.19178Z"
      {...strokeProps}
    />
  </>,
  { displayName: 'DonationIcon', viewBox: '0 0 21 19' }
);
